module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "tnis"
  }, [_vm._v("I can now sing “I am what I am” with true conviction because I allow only the one who made me to define “What I Am.”")]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("I can now sing “I Will Survive” with true conviction because my strength to live and assurance that I will comes from submission to the only one who can create life … "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Jesus Christ.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16eacb0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm.vue
// module id = 69
// module chunks = 0